import { render } from "./PageScrollerNavigation.vue?vue&type=template&id=1c38bed9"
import script from "./PageScrollerNavigation.vue?vue&type=script&lang=js"
export * from "./PageScrollerNavigation.vue?vue&type=script&lang=js"

import "./PageScrollerNavigation.vue?vue&type=style&index=0&id=1c38bed9&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__